var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('pre-base',{ref:"mybase",attrs:{"pre_data":_vm.init_data},on:{"base2-event":_vm.refresh_father}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{attrs:{"id":"notice"}},[_c('h5',[_vm._v("个人费用报销分类使用说明:"),_c('br'),_c('span',[_vm._v("1、如果使用了,只能注销。否则可以直接删除")]),_c('br'),_c('span',[_vm._v("2、查询关键字:名称。")]),_c('br')])])])
}]

export { render, staticRenderFns }